import React from "react";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";

/** Vector adaptation of Assistant / Sparkles in UI kit 7pxtge5x3IXLp8Xhd5hanB, node 2017:3292.
 * Faceted stars, dot and curved tail; normalized to a 30-unit viewport.
 */
export function HomeAssistantSparkles({ isDark }: { isDark: boolean }) {
  const instanceId = React.useId().replace(/[^a-zA-Z0-9_-]/g, '');
  const gradientId = `home-sparkles-${instanceId}-${isDark ? 'dark' : 'light'}`;
  return (
    <Svg
      key={gradientId}
      testID="home-assistant-sparkles-kit"
      width={24}
      height={24}
      viewBox="0 0 30 30"
    >
      <Defs>
        <LinearGradient id={gradientId} gradientUnits="objectBoundingBox" x1="0%" y1="0%" x2="100%" y2="100%">
          <Stop offset="0" stopColor={isDark ? "#FFE8BC" : "#B87560"} />
          <Stop offset="0.5" stopColor={isDark ? "#F4C98E" : "#A56050"} />
          <Stop offset="1" stopColor={isDark ? "#DBA76B" : "#C68D76"} />
        </LinearGradient>
      </Defs>
      <Path
        d="M16.9 0C15.2 8.1 12.2 12.2 5.2 15.2C10.1 16.6 12.4 19.8 13.3 28.2C16.1 19.7 18.1 16.4 24.3 15C19.3 11.7 18.3 7.6 16.9 0Z"
        fill={`url(#${gradientId})`}
      />
      <Path
        d="M16.9 1.9L13.5 26.5C16.1 19.1 18.5 16.6 22.8 15.2C18.7 11.7 18.1 8.2 16.9 1.9Z"
        fill={isDark ? "#FFF0CF" : "#D6A58F"}
      />
      <Path
        d="M4.2 2.4C3.4 6.1 2.8 7.3 0 8.5C2.7 9.3 3.5 10.5 4.2 13.8C5.1 10.6 5.8 9.5 9.3 8C6.4 7.3 5.2 5.9 4.2 2.4Z"
        fill={`url(#${gradientId})`}
      />
      <Path
        d="M26.7 20.9C26 23.9 25.4 24.8 22.1 26C25.3 26.9 26.3 27.7 26.7 30C27.4 27.8 28.2 26.9 30 26.4C28.3 25.3 27.3 24.4 26.7 20.9Z"
        fill={`url(#${gradientId})`}
      />
      <Circle
        cx="26.4"
        cy="4.8"
        r="1.55"
        fill={isDark ? "#F8D39F" : "#D89C83"}
      />
      <Path
        d="M1.9 21.3C3.1 24.9 5.1 27.1 9.2 26.9"
        stroke={isDark ? "#ECC99E" : "#D2A594"}
        strokeWidth={0.8}
        strokeLinecap="round"
        fill="none"
      />
    </Svg>
  );
}
